// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".description[data-v-ac2f7c6a] {\n  font-size: 12px;\n  line-height: 16px;\n  color: #465366;\n  margin-bottom: 10px;\n}\n.segment-checkboxes > .briq-form-element[data-v-ac2f7c6a] {\n  margin-bottom: 0;\n}\n.segment-checkboxes[data-v-ac2f7c6a] {\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
